export default {
  data () {
    return {
      // Appointment Form
      formAppointment: {
        student_name: '',
        student_id: '',
        email: '',
        contact_number: '',
        service_type: '',
        preferred_date: '',
        preferred_time: '',
        purpose: '',
        notes: ''
      },

      // Counseling Appointment Form
      formCounseling: {
        student_name: '',
        student_id: '',
        email: '',
        contact_number: '',
        preferred_date: '',
        preferred_time: '',
        concern_type: '',
        concern_details: ''
      },

      // Job Placement Form
      formJobPlacement: {
        student_name: '',
        student_id: '',
        email: '',
        contact_number: '',
        course: '',
        year_level: '',
        preferred_industry: '',
        skills: '',
        resume_uploaded: false
      },

      // Medical Appointment Form
      formMedical: {
        student_name: '',
        student_id: '',
        contact_number: '',
        preferred_date: '',
        preferred_time: '',
        service_type: '',
        symptoms: ''
      },

      // Contact Form
      formContact: {
        name: '',
        email: '',
        subject: '',
        message: ''
      },

      // Options
      appointmentOptions: {
        concernTypes: [
          { id: 'academic', name: 'Academic Concerns' },
          { id: 'personal', name: 'Personal/Emotional' },
          { id: 'career', name: 'Career Guidance' },
          { id: 'family', name: 'Family Issues' },
          { id: 'relationships', name: 'Relationship Concerns' },
          { id: 'others', name: 'Others' }
        ],
        timeSlots: [
          { id: '08:00', name: '8:00 AM - 9:00 AM' },
          { id: '09:00', name: '9:00 AM - 10:00 AM' },
          { id: '10:00', name: '10:00 AM - 11:00 AM' },
          { id: '11:00', name: '11:00 AM - 12:00 PM' },
          { id: '13:00', name: '1:00 PM - 2:00 PM' },
          { id: '14:00', name: '2:00 PM - 3:00 PM' },
          { id: '15:00', name: '3:00 PM - 4:00 PM' },
          { id: '16:00', name: '4:00 PM - 5:00 PM' }
        ],
        yearLevels: [
          { id: '1', name: '1st Year' },
          { id: '2', name: '2nd Year' },
          { id: '3', name: '3rd Year' },
          { id: '4', name: '4th Year' },
          { id: '5', name: '5th Year / Irregular' }
        ],
        medicalServices: [
          { id: 'consultation', name: 'Medical Consultation' },
          { id: 'first_aid', name: 'First Aid Treatment' },
          { id: 'certificate', name: 'Medical Certificate' },
          { id: 'dental', name: 'Dental Services' },
          { id: 'mental_health', name: 'Mental Health Consultation' }
        ]
      }
    }
  },

  methods: {
    resetAppointmentForm () {
      this.formAppointment = {
        student_name: '',
        student_id: '',
        email: '',
        contact_number: '',
        service_type: '',
        preferred_date: '',
        preferred_time: '',
        purpose: '',
        notes: ''
      }
    },

    validateAppointmentForm () {
      const required = ['student_name', 'student_id', 'email', 'contact_number', 'service_type', 'preferred_date', 'preferred_time', 'purpose']
      const missing = required.filter(field => !this.formAppointment[field])

      if (missing.length > 0) {
        this.$bvToast.toast('Please fill in all required fields', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true
        })
        return false
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.formAppointment.email)) {
        this.$bvToast.toast('Please enter a valid email address', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true
        })
        return false
      }

      return true
    },

    resetCounselingForm () {
      this.formCounseling = {
        student_name: '',
        student_id: '',
        email: '',
        contact_number: '',
        preferred_date: '',
        preferred_time: '',
        concern_type: '',
        concern_details: ''
      }
    },

    resetJobPlacementForm () {
      this.formJobPlacement = {
        student_name: '',
        student_id: '',
        email: '',
        contact_number: '',
        course: '',
        year_level: '',
        preferred_industry: '',
        skills: '',
        resume_uploaded: false
      }
    },

    resetMedicalForm () {
      this.formMedical = {
        student_name: '',
        student_id: '',
        contact_number: '',
        preferred_date: '',
        preferred_time: '',
        service_type: '',
        symptoms: ''
      }
    },

    resetContactForm () {
      this.formContact = {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    },

    validateCounselingForm () {
      const required = ['student_name', 'student_id', 'email', 'contact_number', 'preferred_date', 'preferred_time', 'concern_type']
      const missing = required.filter(field => !this.formCounseling[field])

      if (missing.length > 0) {
        this.$bvToast.toast('Please fill in all required fields', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true
        })
        return false
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.formCounseling.email)) {
        this.$bvToast.toast('Please enter a valid email address', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true
        })
        return false
      }

      return true
    },

    validateJobPlacementForm () {
      const required = ['student_name', 'student_id', 'email', 'contact_number', 'course', 'year_level']
      const missing = required.filter(field => !this.formJobPlacement[field])

      if (missing.length > 0) {
        this.$bvToast.toast('Please fill in all required fields', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true
        })
        return false
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.formJobPlacement.email)) {
        this.$bvToast.toast('Please enter a valid email address', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true
        })
        return false
      }

      return true
    },

    validateMedicalForm () {
      const required = ['student_name', 'student_id', 'contact_number', 'preferred_date', 'preferred_time', 'service_type']
      const missing = required.filter(field => !this.formMedical[field])

      if (missing.length > 0) {
        this.$bvToast.toast('Please fill in all required fields', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true
        })
        return false
      }

      return true
    },

    validateContactForm () {
      const required = ['name', 'email', 'subject', 'message']
      const missing = required.filter(field => !this.formContact[field])

      if (missing.length > 0) {
        this.$bvToast.toast('Please fill in all required fields', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true
        })
        return false
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.formContact.email)) {
        this.$bvToast.toast('Please enter a valid email address', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true
        })
        return false
      }

      return true
    }
  }
}
